export default class Highlighter {

  highlight(text, target_str) {
    if (!target_str) {
      return text
    }
    return text.replace(new RegExp(target_str, 'gi'), `<mark>$&</mark>`)
  }
}
